@if (criterias(); as criterias) {
  <div class="criteria-list">

    <mat-toolbar>
      <span>In - and Exclusion criteria</span>
      @if (editable()) {
        <span class="spacer"></span>
        <button mat-raised-button
                aria-label="Create Criterias"
                (click)="create()"
        >
          <mat-icon>add</mat-icon>
          <span>Add Criteria</span>
        </button>
      }
    </mat-toolbar>

    @if (isSmallScreen()) {
      <div class="criteria-cards">
        @for (criteria of criterias; track criteria.id) {
          <mat-card class="criteria-card" (click)="openDialog(criteria)">
            <mat-card-header>
              <mat-card-title class="criteria-card--name">{{ criteria.name }}</mat-card-title>
              <mat-card-subtitle class="criteria-card--include">{{ criteria.includeCriteria ? 'Include' : 'Exclude' }}
              </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <p class="criteria-card--criteria">{{ criteria.criteria }}</p>
            </mat-card-content>
          </mat-card>
        }
      </div>
    } @else {

      <table mat-table [dataSource]="criterias" [class.editable]="editable()">

        <ng-container matColumnDef="and">
          <th mat-header-cell *matHeaderCellDef class="td-and"></th>
          <td mat-cell *matCellDef="let keyword; let i = index;" class="td-and">
            @if (i > 0) {
              <mat-icon
                matTooltip="AND"
              >add
              </mat-icon>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="includeCriteria">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell class="exclude-td"
              *matCellDef="let criteria"> {{ criteria.includeCriteria ? 'Include' : 'Exclude' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name</th>
          <td mat-cell *matCellDef="let criteria"> {{ criteria.name }}</td>
        </ng-container>


        <ng-container matColumnDef="criteria">
          <th mat-header-cell *matHeaderCellDef>
            Criteria
          </th>
          <td mat-cell *matCellDef="let criteria">
            {{ getPreviewStatement(criteria) }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openDialog(row)"></tr>
      </table>

      <app-info-card size="SMALL" [marginTop]="true">
        <span subtitle>
          Your criteria are fully customizable — update them anytime to suit your evolving needs.
        </span>
      </app-info-card>
    }
  </div>
}
